module.exports = __webpack_public_path__ + "img/delete-account-illustration.aa122ed9.svg";